import { render, staticRenderFns } from "./approvalfrm.vue?vue&type=template&id=72e1fc25"
import script from "./approvalfrm.vue?vue&type=script&lang=js"
export * from "./approvalfrm.vue?vue&type=script&lang=js"
import style0 from "./approvalfrm.vue?vue&type=style&index=0&id=72e1fc25&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports